import React, { useEffect, useState } from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useHistory, useLocation } from 'react-router-dom';
import { MultipleEdits } from './components/Modal';
import { EDIT_ROUTES } from '../../../utils/adEditRoutes';

function getFabricationYears(cumulativeModeYear?: number, anoModelo?: number) {
  if (cumulativeModeYear) {
    return [cumulativeModeYear, cumulativeModeYear - 1];
  }
  if (anoModelo) {
    return [anoModelo, anoModelo - 1];
  }
}

export function FabricationYearForm(): JSX.Element {
  const location = useLocation();
  const history = useHistory();
  const { setCurrentContent, loading, initialLoading, error, pushToCumulativeChanges } = useAd();
  const {
    currentAd,
    setValueIsDifferentFromCurrent,
    setCurrentWarningMessage,
    cumulativeChanges,
    setCurrentTabDepth
  } = useAdContext();

  const { anoModelo, anoFabricacao } = currentAd?.veiculo || {};
  const [selectedRadio, setSelectedRadio] = useState(
    cumulativeChanges?.veiculo?.anoFabricacao
      ? cumulativeChanges?.veiculo?.anoFabricacao
      : anoFabricacao
  );
  const [modalOpen, setModalOpen] = useState(false);

  const versionUrl = location.pathname.replace(
    EDIT_ROUTES.fabricationYear.name,
    EDIT_ROUTES.version.name
  );

  const fabricationYears = getFabricationYears(cumulativeChanges?.veiculo?.anoModelo, anoModelo);

  useEffect(() => {
    setValueIsDifferentFromCurrent(selectedRadio !== anoFabricacao);
  }, [selectedRadio, anoFabricacao, setValueIsDifferentFromCurrent]);

  useEffect(() => {
    if (error?.fieldMissing) {
      setModalOpen(true);
      setCurrentWarningMessage({
        title: 'deseja confirmar as alterações?',
        body: 'Para salvar a alteração do ano de fabricação do seu veículo você precisará confirmar também a versão.',
        redirect: versionUrl
      });
    }
  }, [error, versionUrl, setCurrentWarningMessage]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          qual o ano de fabricação do seu carro?
        </Title>
      </OpenEditTitleWrapper>
      {(initialLoading || loading) && <Loading backgroundOnly={loading} />}

      <List>
        {fabricationYears ? (
          fabricationYears.map(year => {
            const yearAsString = String(year);
            return (
              <ListItemModifier key={yearAsString} isNormalCase>
                <ListItem
                  label={yearAsString}
                  variant="selector"
                  radioOnChange={() => setSelectedRadio(year)}
                  radioValue={yearAsString}
                  radioChecked={year === selectedRadio}
                  selectorName={yearAsString}
                  selectorVariant="radio"
                />
              </ListItemModifier>
            );
          })
        ) : (
          <></>
        )}
      </List>

      {!(initialLoading && selectedRadio === anoFabricacao) && (
        <SaveFormContent
          loading={loading}
          isDisabled={selectedRadio === anoFabricacao && !cumulativeChanges?.veiculo?.anoModelo}
          isBody
          handleClick={() => {
            if (cumulativeChanges?.veiculo?.anoModelo && selectedRadio) {
              setCurrentTabDepth(state => state + 1);
              pushToCumulativeChanges({
                veiculo: {
                  anoFabricacao: selectedRadio
                }
              });
              return history.push(versionUrl);
            }
            setCurrentContent({
              veiculo: {
                anoFabricacao: selectedRadio
              }
            });
          }}
        />
      )}

      <MultipleEdits
        title="deseja editar o ano de fabricação?"
        body="Ao editar o ano de fabricação do seu veículo você precisará confirmar também a versão."
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        handleContinue={() => {
          setCurrentTabDepth(state => state + 1);
          history.push(versionUrl);
        }}
        handleBack={() => {
          setModalOpen(false);
        }}
      />
    </OpenEditWrapper>
  );
}
